package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class StatsChartDto(
    val period: String,
    val dataPoints: List<ChartDataPointDto>
)

@Serializable
data class ChartDataPointDto(
    val label: String,
    val stats: Map<String, Int>
)
